



























import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Vue from 'vue'
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons'
import { Dealer } from '~/models/dealer/types'
import CClusterMap from '~/components/shared/configurable/map/CClusterMap.vue'
import MapPopupShimmer from './MapPopupShimmer.vue'
import MapPopup from './MapPopup.vue'
import {
  SET_ACTIVE_DEALER,
  SET_ACTIVE_GEOLOCATION,
  SET_HOVERED_DEALER,
  SET_PARAM
} from '~/store/modules/shared/dealers/map/mutation-types'
import { Geolocation } from '~/models/common/types'
import {
  DEALERS_MAP_NS,
  DealersMapState
} from '~/store/modules/shared/dealers/map/state'
import { faIconToSvg } from '~/utils/icon'
import GoogleMapsService from '~/services/GoogleMapsService'
import DealersPreviewService from '~/services/dealers/preview/DealersPreviewService'

export default Vue.extend({
  components: { CClusterMap },
  data() {
    return {
      mapMounted: false,
      maxBounds: {
        lat: { max: 46.5, min: 31 },
        lon: { max: 36, min: 16 }
      },
      popupShimmerContent: null
    }
  },
  computed: {
    ...mapState<DealersMapState>(DEALERS_MAP_NS, {
      markers: (state): Geolocation[] => state.markers,
      hoveredDealer: (state): Dealer => state.hoveredDealer,
      activeGeolocation: (state): Geolocation => state.activeGeolocation,
      activeDealer: (state): Dealer => state.activeDealer,
      mobileListVisible: (state): boolean => state.mobile.listVisible
    }),
    ...mapGetters(DEALERS_MAP_NS, {
      facetsCount: 'getFacetsCount'
    }),
    buttons() {
      return [
        {
          title: this.$t('my place'),
          position: 'topright',
          event: 'clicked:btnLocation',
          styles: {
            color: '#ffffff',
            backgroundColor: 'rgba(33, 33, 33, 0.8)',
            lineHeight: '32px',
            fontSize: '16px',
            cursor: 'pointer',
            marginRight: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 1px'
          },
          html: faIconToSvg(faCrosshairs),
          tooltip: 'tooltip',
          callback: this.handleGpsLocation
        }
      ]
    }
  },
  watch: {
    activeDealer(newActiveDealer) {
      if (newActiveDealer && newActiveDealer.geolocation) {
        this.$refs.dealersMap.flyTo(
          newActiveDealer.geolocation.lat,
          newActiveDealer.geolocation.lon
        )
      }
    },
    mobileListVisible(isVisible: boolean) {
      this.$refs.dealersMap.visibilityChanged(!isVisible)
    }
  },
  mounted() {
    this.initializePopupPendingContent()
  },
  methods: {
    ...mapActions(DEALERS_MAP_NS, {
      search: 'search'
    }),
    ...mapMutations(DEALERS_MAP_NS, {
      setActiveGeolocation: SET_ACTIVE_GEOLOCATION,
      setHoveredDealer: SET_HOVERED_DEALER,
      setActiveDealer: SET_ACTIVE_DEALER,
      setParam: SET_PARAM
    }),
    handleMapMounted() {
      this.mapMounted = true
    },
    async handleGpsLocation() {
      const googleMapsService = this.$dep(GoogleMapsService)
      const geolocation: Geolocation = await googleMapsService.getCurrentGpsGeolocation()
      const results = await googleMapsService.geocode({
        location: {
          lat: geolocation.lat,
          lng: geolocation.lon
        }
      })
      const postalCode: string = googleMapsService.extractPostalCode(results)
      this.setActiveGeolocation(geolocation)
      this.setParam({ name: 'postcode', value: null })
      if (postalCode) {
        this.setParam({ name: 'postcode', value: postalCode })
        await this.$store.dispatch('dealers/map/search', { updateUrl: true })
      }
    },
    async provideMarkerContent(dealerId) {
      const dealersPreviewService = this.$dep(DealersPreviewService)
      const dealer = await dealersPreviewService.getPreview(dealerId)
      const dealersMapPopup = new Vue({
        ...MapPopup,
        parent: this,
        propsData: {
          dealer
        }
      })
      await dealersMapPopup.$mount()
      const dealersMapPopupHTML = dealersMapPopup.$el
      dealersMapPopup.$destroy()
      return dealersMapPopupHTML
    },
    async initializePopupPendingContent() {
      const popupShimmer = new Vue({
        ...MapPopupShimmer,
        parent: this
      })
      await popupShimmer.$mount()
      this.popupShimmerContent = popupShimmer.$el
      popupShimmer.$destroy()
    },
    provideMarkerPendingContent() {
      return this.popupShimmerContent
    },
    updateBounds(newBounds) {
      const geolocationStr = `${newBounds.topRight.lat}x${newBounds.topRight.lon},${newBounds.bottomLeft.lat}x${newBounds.bottomLeft.lon}`
      this.setParam({ name: 'geolocation', value: geolocationStr })
      this.setParam({ name: 'pg', value: 1 })
      this.search()
    },
    move(movement) {
      if (movement === 'end') {
        this.setHoveredDealer(null)
        this.setActiveDealer(null)
      }
    }
  }
})
